import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
import More from './views/More.vue'
import Power from './views/Power.vue'
import Airtime from './views/Airtime.vue'
import Data from './views/Data.vue'
import Tv from './views/TV.vue'
import About from './views/more/About.vue'
import Terms from './views/more/Terms.vue'
import iRechargePlus from './views/more/iRechargePlus.vue'
import iRechargeCorporate from './views/more/iRechargeCorporate.vue'
import iRechargeBiz from './views/more/iRechargeBiz.vue'
import iRechargeApi from './views/more/iRechargeApi.vue'
import iRechargePerks from './views/more/iRechargePerks.vue'
import RequestToken from './views/RequestToken.vue'
import iRechargePay from './views/more/iRechargePay.vue'
import Transaction from './views/more/Transaction.vue'
import Logout from './components/partials/Logout.vue'
import ResetPasswordPage from './components/partials/ResetPasswordPage.vue'
import LoginPage from './components/partials/LoginPage.vue'
import MerchantAnouncement from './components/partials/MerchantAnouncement.vue'
import VendorAccountNo from './views/VendorAccountNo.vue'
import power_charges from './views/PowerCharges.vue'
import CostComponent from './views/CostComponent.vue'
import Adept from './views/Adept.vue'

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'power',
      component: Power
    },
    // {
    //   path: '/power/tariffs',
    //   name: 'power_tariffs',
    //   component: power_charges
    // },
    {
        path: '/power/tariff/:image',
        name: 'cost',
        component: CostComponent
    },
    {
      path: '/airtime',
      name: 'airtime',
      component: Airtime
    },
    {
      path: '/provision_account',
      name: 'ProvisionAccount',
      component: VendorAccountNo
    },
    {
      path: '/data',
      name: 'data',
      component: Data
    },
    {
      path: '/tv',
      name: 'tv',
      component: Tv
    },
    {
      path: '/more',
      name: 'More',
      component: More
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/terms-and-condition',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/irecharge_plus',
      name: 'iRechargePlus',
      component: iRechargePlus
    },
    {
      path: '/irecharge_corporate',
      name: 'iRechargeCorporate',
      component: iRechargeCorporate
    },
    {
      path: '/irecharge_merchant',
      name: 'iRechargeBiz',
      component: iRechargeBiz
    },
    {
      path: '/irecharge_api',
      name: 'iRechargeApi',
      component: iRechargeApi
    },
    {
      path: '/irecharge_perks',
      name: 'iRechargePerks',
      component: iRechargePerks
    },
    {
      path: '/request_token',
      name: 'RequestToken',
      component: RequestToken
    },
    {
      path: '/irecharge_pay',
      name: 'iRechargePay',
      component: iRechargePay
    },
    {
      path: '/transaction',
      name: 'Transaction',
      component: Transaction
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/reset_password',
      name: 'resetPasswordPage',
      component: ResetPasswordPage
    },
    {
      path: '/get_my_account',
      name: 'Adept',
      component: Adept
    },
    {
      path: '/merchant_announcement',
      name: 'MerchantAnouncement',
      component: MerchantAnouncement
    },
  ]
})
